module.exports = __webpack_public_path__ + "media/images/common/about/icon_sport-fa1476aad5d6ce5e2724dc527cd11201.svg";